<template>
  <v-row dense class="py-0">
    <!-- Kolory standardowe -->
    <v-dialog
      v-model="showDialogStdColor"
      scrollable
      max-width="75%"
      @keydown.esc="CloseStdColor()"
      tabindex="0"
    >
      <v-card>
        <v-card-title>{{
          $t("ProductionTerms.H_Color") +
          " " +
          $t("ProductionTerms.Inne.standardowe")
        }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-3">
          <v-row>
            <template v-for="el in getStdColor(profilProducer)">
              <v-col
                :key="el.Name"
                class="col-12 col-sm-6 col-md-4 col-lg-3 bottom"
              >
                <v-hover v-slot="{ hover }">
                  <v-card
                    :elevation="hover ? 12 : 2"
                    :class="{ 'on-hover': hover }"
                  >
                    <v-img
                      contain
                      :lazy-src="el.File"
                      :src="el.File"
                      class="white--text align-top"
                      gradient="to top, rgba(0,0,0,0), rgba(0,0,0,.3)"
                    >
                      <v-card-title
                        :class="hover ? `text-button` : `text-overline`"
                      >
                        {{t_db("ProductionTerms.ColorsStd",el.Name) }}
                      </v-card-title>
                    </v-img>
                  </v-card>
                </v-hover>
              </v-col>
            </template>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn centered @click="showDialogStdColor = !showDialogStdColor">
            {{ $t("Close") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Kalendarz dni wolnych lgAndUp -->
    <v-dialog
      v-if="$vuetify.breakpoint.lgAndUp"
      v-model="showCalendar"
      hide-overlay
      origin="right center"
      scrollable
      @keydown.esc="closeEvents"
      @keydown.enter="closeEvents"
      tabindex="0"
      width="60%"
    >
      <v-card class="px-3 py-2">
        <!-- <v-card-title>Dodatkowe przerwy techniczne i dni wolne</v-card-title> -->
        <v-card-text class="py-0">
          <v-row>
            <v-col cols="5">
              <v-date-picker
                ref="picker"
                no-title
                :first-day-of-week="1"
                v-model="date"
                :picker-date.sync="pickerDate"
                :events="events"
                event-color="red"
                scrollable
                :locale="getLang()"
                readonly
              ></v-date-picker>
            </v-col>

            <v-col cols="7">
              <v-fade-transition>
                <v-subheader
                  dense
                  class="text-subtitle-1"
                  v-if="filteredCalendar.length"
                >
                  {{ pickerDate }}
                </v-subheader>
              </v-fade-transition>

              <v-virtual-scroll
                :items="filteredCalendar"
                item-height="25"
                height="212"
              >
                <template v-slot:default="{ item }">
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        <span class="mr-2 text-subtitle-2">
                          {{item.date}}</span>
                        <span class="text-body-2">
                          {{ t_db('ProductionTerms.Holidays', item.name) }}
                        </span></v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="5">
              <v-date-picker
                ref="picker1"
                no-title
                :first-day-of-week="1"
                :picker-date.sync="pickerDate1"
                :events="events"
                event-color="red"
                scrollable
                :locale="getLang()"
                readonly
              ></v-date-picker>
            </v-col>
            <v-col cols="7">
              <v-fade-transition>
                <v-subheader
                  dense
                  class="text-subtitle-1"
                  v-if="filteredCalendar1.length"
                >
                  {{ pickerDate1 }}
                </v-subheader>
              </v-fade-transition>
              <v-virtual-scroll
                :items="filteredCalendar1"
                item-height="25"
                height="212"
              >
                <template v-slot:default="{ item }">
                  <v-list-item dense>
                    <v-list-item-content>
                      <v-list-item-subtitle>
                        <span class="mr-2 text-subtitle-2">{{
                          item.date
                        }}</span>
                        <span class="text-body-2">
                          {{t_db('ProductionTerms.Holidays', item.name)}}
                        </span></v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-virtual-scroll>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-1">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeEvents()">
            {{ $t("Close") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Kalendarz dni wolnych ponizej lg  -->
    <v-dialog
      v-else
      v-model="showCalendar"
      hide-overlay
      origin="right center"
      scrollable
      @keydown.esc="closeEvents"
      @keydown.enter="closeEvents"
      tabindex="0"
      max-width="350"
    >
      <v-card class="px-3 pt-2 pb-0" height="550">
        <v-card-text class="px-0 py-0">
          <v-list-item
            two-line
            dense
            v-for="(item, i) in filteredCalendar2"
            :key="i"
          >
            <v-list-item-content>
              <span class="mr-2 text-subtitle-2">{{ item.date }}</span>

              <v-list-item-subtitle>
                <span class="text-body-2">{{ t_db('ProductionTerms.Holidays', item.name) }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-1">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="closeEvents()">
            {{ $t("Close") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Tabela z informacjami o poszczególnych typach profili -->
    <!-- logo producenta profili -->
    <v-col
      class="col-12 col-lg-2 text-center d-flex justify-center"
      align-self="center"
    >
      <producer-logo
        :producer="{
          producer: profilDatas[0].customerCode,
          profil: profilDatas[0].profil,
        }"
      >
      </producer-logo>
    </v-col>

    <!-- Pozostałe informacje o rodzajach i czasu produkcji -->
    <v-col class="col-12 col-lg-10 py-0" align-self="center">
      <v-sheet
        v-for="color in chkColors(profilDatas)"
        :key="color"
        color="grey lighten-5"
        class="my-1"
      >
        <v-row dense>
          <v-col
            v-if="$vuetify.breakpoint.lgAndUp"
            class="col-12 col-md-3 text-center text-subtitle-2"
            align-self="center"
            @click="showDialogStdColor = !showDialogStdColor"
            >{{ t_db('ProductionTerms.Inne', color) }}
            <v-icon
              v-if="color == $t('ProductionTerms.Inne.standardowe', 'pl') && getStdColor(profilProducer).length"
              small
              color="blue lighten-2"
              >mdi-information-variant
            </v-icon>
          </v-col>
          <v-col
            v-else
            class="col-12 col-md-3 text-center text-subtitle-2"
            align-self="center"
            >{{ $t("ProductionTerms.H_Color") }} {{ t_db('ProductionTerms.Inne', color) }}
            <v-icon
              v-if="color == $t('ProductionTerms.Inne.standardowe', 'pl') && getStdColor(profilProducer).length"
              @click="showDialogStdColor = !showDialogStdColor"
              small
              color="blue lighten-3"
              >mdi-information-variant
            </v-icon>
          </v-col>

          <v-col class="col-12 col-md-7 py-0" align-self="center">
            <v-sheet
              v-for="product in chkProducts(profilDatas, color)"
              :key="product"
              color="grey lighten-4"
            >
              <v-row dense class="mt-1">
                <v-col class="col-3 py-0 pr-4 text-right" align-self="center">
                  {{ t_db('ProductionTerms.Inne', product) }}
                </v-col>
                <v-col class="col-9 py-0">
                  <v-sheet
                    v-for="row in readRows(profilDatas, product, color)"
                    :key="row.id"
                    color="grey lighten-3"
                  >
                    <v-row class="mt-1 my-sm-0" dense>
                      <v-col
                        class="col-6 py-0 text-right"
                        align-self="center"
                        >{{ t_db('ProductionTerms.Inne', row.info) }}</v-col
                      >
                      <v-col class="col-6 py-0" align-self="center">
                        <v-row dense>
                          <v-col
                            v-if="$vuetify.breakpoint.lgAndUp"
                            class="col-12 col-sm-4 py-0 text-center"
                            align-self="center"
                            >{{ row.days }}</v-col
                          >
                          <v-col
                            v-else
                            class="col-12 col-sm-4 py-0 text-center"
                            align-self="center"
                            >{{ row.days }}
                            {{ $t("ProductionTerms.H_Days") }}
                          </v-col>

                          <v-col
                            class="col-12 col-sm-8 py-0 text-center"
                            @click="
                              haveEvents(row.dateTerm)
                                ? showEvents(row.dateTerm)
                                : ''
                            "
                            :style="{
                              cursor: haveEvents(row.dateTerm) ? 'pointer' : '',
                            }"
                          >
                            <v-badge
                              :content="haveEvents(row.dateTerm)"
                              :value="haveEvents(row.dateTerm)"
                              dot
                              inline
                              color="orange"
                            >
                              <span>{{ row.dateTerm.substr(0, 10) }}</span>
                            </v-badge>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-sheet>
          </v-col>
          <v-col class="col-12 col-md-2 text-center" align-self="center">
            <v-icon>mdi-plus</v-icon>
            <v-icon x-large>mdi-truck-fast</v-icon>
            <p class="text-caption ma-0">
              {{ $t("ProductionTerms.AccToArrangements") }}
            </p>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>
  </v-row>
</template>
<script>
import producerLogo from "@/components/Others/ProductionTerms/PT_producerLogo.vue";
import axios from "axios";

export default {
  props: {
    profilDatas: {},
    profilProducer: null,
  },
  components: {
    producerLogo,
  },
  data() {
    return {
      lang: "pl",
      showDialogStdColor: false,
      showCalendar: false,

      calendar: [],
      filteredCalendar: [],
      filteredCalendar1: [],
      filteredCalendar2: [],
      events: [],

      date: null,
      pickerDate: null,
      pickerDate1: null,
      pickerDate2: null,

      mouseDay: null,
      mouseEvent: null,

      stdColor: [
        {
          Producer: "KN",
          Name: "Antracyt (70)",
          File: require("@/assets/ColorsStd/SALAMANDER/small_Antracyt (70).png"),
        },
        {
          Producer: "KN",
          Name: "Dab bagienny (25)",
          File: require("@/assets/ColorsStd/SALAMANDER/small_Dab bagienny (25).png"),
        },
        {
          Producer: "KN",
          Name: "Mahoń (26)",
          File: require("@/assets/ColorsStd/SALAMANDER/small_Mahon (26).png"),
        },
        {
          Producer: "KN",
          Name: "Orzech (21)",
          File: require("@/assets/ColorsStd/SALAMANDER/small_Orzech (21).png"),
        },
        {
          Producer: "KN",
          Name: "Złoty dąb (51)",
          File: require("@/assets/ColorsStd/SALAMANDER/small_Zloty dab ( 51).png"),
        },
        {
          Producer: "SALAMANDER",
          Name: "Antracyt (70)",
          File: require("@/assets/ColorsStd/SALAMANDER/small_Antracyt (70).png"),
        },
        {
          Producer: "SALAMANDER",
          Name: "Dab bagienny (25)",
          File: require("@/assets/ColorsStd/SALAMANDER/small_Dab bagienny (25).png"),
        },
        {
          Producer: "SALAMANDER",
          Name: "Mahoń (26)",
          File: require("@/assets/ColorsStd/SALAMANDER/small_Mahon (26).png"),
        },
        {
          Producer: "SALAMANDER",
          Name: "Orzech (21)",
          File: require("@/assets/ColorsStd/SALAMANDER/small_Orzech (21).png"),
        },
        {
          Producer: "SALAMANDER",
          Name: "Złoty dąb (51)",
          File: require("@/assets/ColorsStd/SALAMANDER/small_Zloty dab ( 51).png"),
        },
        {
          Producer: "ALUPLAST SP. Z O.O.",
          Name: "Złoty dąb (23)",
          File: require("@/assets/ColorsStd/ALUPLAST/small_23 Zloty dab.png"),
        },
        {
          Producer: "ALUPLAST SP. Z O.O.",
          Name: "Orzech (27)",
          File: require("@/assets/ColorsStd/ALUPLAST/small_27 Orzech.png"),
        },
        {
          Producer: "ALUPLAST SP. Z O.O.",
          Name: "Antracyt (40)",
          File: require("@/assets/ColorsStd/ALUPLAST/small_40 Antracyt.png"),
        },
        {
          Producer: "ALUPLAST SP. Z O.O.",
          Name: "Antracyt piaskowany satin (60)",
          File: require("@/assets/ColorsStd/ALUPLAST/small_60 Antracyt piaskowany_satin.png"),
        },
      ],
    };
  },
  computed: {},
  methods: {
    t_db(key,value) {
      var text = '';

      if (value != '') {
        if (this.$t(`${key}.${value}`) == `${key}.${value}`)
          {text = `noTranslateKey_${value}`} 
        else text= this.$t(`${key}.${value}`)}
      return text;
    },

    getLang() {
      var language = "";
      if (this.$cookies.isKey("TPLanguage") == true)
        language = this.$cookies.get("TPLanguage");
      this.lang = language;
      return language;
    },

    getStdColor(producer) {
      var tab = [];
      this.stdColor.forEach((row) => {
        if (row.Producer == producer) tab.push(row);
      });
      return tab;
    },

    haveEvents(date) {
      var tab = [];

      var today = new Date().toISOString().substr(0, 10);
      this.calendar.forEach(function (element) {
        if (element.date >= today && element.date <= date) {
          tab.push(element);
        }
      });
      return tab.length ? true : false;
    },

    showEvents(date) {
      // lg i powyżej filtrowane tablice eventow odpowiadajace kalendarzom napełniane są w zależności od wyboru daty na kalendarzach

      this.date = new Date().toISOString().substr(0, 10);
      this.pickerDate = this.date.substr(0, 7);
      this.showCalendar = true;
      // Ponizej lg napełniana jest tablica filtrowana i nie ma mozliwosci zmian na kalendarzu
      if (date != null) {
        var d = date.substr(0, 10);
        this.calendar.forEach((row) => {
          // wpisy od bieżącej daty do końca miesiąca daty końcowej
          if (
            row.date >= this.date &&
            (row.date <= d || row.date.substr(0, 7) <= d.substr(0, 7))
          ) {
            this.filteredCalendar2.push(row);
          }
        });
      }
    },

    closeEvents() {
      this.showCalendar = false;
      this.filteredCalendar2 = [];
    },

    calendarEvents() {
      var tab = [];
      this.calendar.forEach(function (element) {
        tab.push(element.date);
      });
      this.events = tab.slice();
      return tab;
    },

    mouseEnter(month) {
      this.mouseDay = month;
      this.mouseEvent = this.readCalendarInfo(month);
      this.date = month;
    },
    readCalendarInfo(day) {
      var info = "";
      if (this.calendar.findIndex((element) => element.date == day) >= 0) {
        info = this.calendar.find((element) => element.date == day).name;
      }
      return info;
    },

    mouseLeave() {
      this.mouseDay = null;
    },

    showEventsTab(YearMonth) {
      var tab = [];
      this.calendar.forEach((element) => {
        if (element.date.substr(0, 7) == YearMonth) {
          tab.push(element);
        }
      });
      tab.sort();
      return tab;
    },

    CloseStdColor() {
      this.showDialogStdColor = !this.showDialogStdColor;
    },

    colorStd(txt) {
      return txt.indexOf("standard") >= 0 ? true : false;
    },
    chkColors(records) {
      var tab = [];
      records.forEach((element) => {
        if (tab.indexOf(element.color) == -1) {
          tab.push(element.color);
        }
      });
      return tab;
    },
    chkProducts(records, color) {
      var tab = [];
      records.forEach((element) => {
        if (tab.indexOf(element.product) == -1 && element.color == color) {
          tab.push(element.product);
        }
      });
      return tab;
    },

    readRows(records, product, color) {
      var tab = [];
      records.forEach((element) => {
        if (element.color == color && element.product == product) {
          tab.push(element);
        }
      });
      return tab;
    },

    //API - pobieranie terminów realizacji
    async getProductsTermsCalendar() {
      window.Store.dispatch("sessionAuthorise").then((response) => {
        if (response.respond == "logged") {
          axios
            .post(
              window.API.ProductsTermsCalendar,
              window.Store.getters.getAxiosHeader
            )
            .then((response) => {
              if (response.data.length > 0) {
                this.calendar = response.data;
                this.calendar.forEach(function (element) {
                  element.date = element.date.substr(0, 10);
                });
                this.calendarEvents();
              }
            })
            .catch((errors) => {
              const errorStatus = errors.response;
              if (errorStatus == 401) {
                window.Store.dispatch("logout");
              }
            });
        } else {
          window.Store.dispatch("logout");
        }
      });
    },
  },
  created() {
    this.getProductsTermsCalendar();
    this.getLang();
  },
  watch: {
    pickerDate(val) {
      var tab = [];
      if (val != null) {
        var year = val.substr(0, 4);
        var month = val.substr(5, 2);

        if (val.substr(5, 2) == "12") {
          year = (Number(year) + 1).toString();
          month = "01";
        } else {
          month = (Number(month) + 1).toString();
          if (month.length == 1) month = "0" + month;
        }
        this.pickerDate1 = year + "-" + month;

        this.calendar.forEach((element) => {
          if (element.date.substr(0, 7) === val) {
            tab.push(element);
          }
        });
        this.filteredCalendar = tab.slice();
      }
    },

    pickerDate1(val) {
      var tab = [];

      if (val != null) {
        var year = val.substr(0, 4);
        var month = val.substr(5, 2);

        if (month == "01") {
          year = (Number(year) - 1).toString();
          month = "12";
        } else {
          month = (Number(month) - 1).toString();
          if (month.length == 1) month = "0" + month;
        }
        this.pickerDate = year + "-" + month;

        this.calendar.forEach((element) => {
          if (element.date.substr(0, 7) === val) {
            tab.push(element);
          }
        });
        this.filteredCalendar1 = tab.slice();
      }
    },
  },
};
</script>

